<template lang="pug">
  .premium
    .loading-container(v-bind:class="{ 'active': loading }")
      h2(v-if="loading == true")
        center Processing... Please don't refresh this page
      loading(:active.sync="loading" :is-full-page="false")
    .loading-not(v-if="loading == false")
      h1 Success
      p Your payment has been confirmed. Thank you for your purchase.
      hr
      .feature-box.payment(v-if="payment.id !== undefined")
        .title
          h2 Payment Reference
        .content
          p This payment has been saved to our system. If you need a record of this, please see below:
          hr
          table.payment-ref-table
            tr(v-for="d in Object.keys(payment)")
              td.column {{ $t('fields.' + d) }}
              td(v-if="payment[d] == 'initial'") {{ $t('fields.' + payment[d]) }}
              td(v-else) {{ payment[d] }}
          //- pre {{ payment }}
      .feature-box
        .title
          h2 Get Started
        .content
          p Your account is now 
            strong PREMIUM
            | , get started by visiting your dashboard and viewing your available documents.
            router-link(to="/dashboard").no-dec
              Button(type="secondary small-width center") Dashboard
</template>

<script>
  import AuthService from '@/services/auth.js'
  import PaymentService from '@/services/payment.js'

  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: { Loading },
    data: function() {
      return {
        loading: true,
        payment: []
      }
    },
    methods: {
      async check_premium() {
        let item = this;
        try {
          this.loading = true;
          const response = await AuthService.is_premium();

          if(response) {
            // we're setting the user and token.. saving to store..
            const is_premium = (response.data === true ? true : false);
            if(is_premium == true) {
              const latest_payment = await item.get_latest_payment();
            }

            item.$store.dispatch('setPremium', is_premium)
            item.loading = false;
          } else {
            item.loading = false;
          }
          
        } catch(error) {
          item.loading = false;
          if(error.response === undefined)
            return item.error = 'Could not get request.';
        } 
      },
      async get_latest_payment() {
        let item = this;
        try {
          item.loading = true;
          const response = await PaymentService.get_my_latest();

          if(response) {
            console.log('/// get_latest_payment');
            console.log(response.data);
            item.payment = response.data;
            item.loading = false;
          } else {
            console.log('/// get_latest_payment, no response..');
            console.log(response.data);
            item.loading = false;
          }
          
        } catch(error) {
          console.log(error);
          item.loading = false;
          if(error.response === undefined)
            return item.error = 'Could not get request.';
        } 
      }
    },
    mounted: function () {
      let item = this;
      setTimeout(function() {
        item.check_premium();
      }, 4800);
    }
  }
</script>

<style lang="scss" scoped>
  .premium {
    h1 {
      margin-bottom:14px;
      font-size:24px;
    }
    hr {
      margin: 24px 0px;
    }
  }
  .loading-container {
    width:100%;
    height:0px;
    transition: height 200ms ease;
    &.active {
      min-height:300px;
    }
    position:relative;
  }
  .feature-box {
    max-width:450px;
    &.payment {
      max-width:510px;
      width:95%;
    }
    float:left;
    margin-right:24px;
    margin-bottom:15px;
    background:#eee;
    .payment-ref-table {
      .column {
        text-indent:16px;
        font-weight:600;
      }
      td,tr {
        font-size:14px;
        padding:0;
        line-height:36px;
      }
    }
    .title {
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      background:$primary;
      line-height:55px;
      h2 {
        font-size:16px;
        color:#fff;
        margin-left:18px;
      }
    }
    .content {
      padding:24px;
      background:#eee;
      box-shadow: 0 22px 15px -22px #000;
    }
  }
</style>